'use client'

import { Builder, withChildren } from '@builder.io/react'

import { AlignItems, Flex, JustifyContent } from './Flex'

Builder.registerComponent(withChildren(Flex), {
  name: 'Flex',
  inputs: [
    {
      name: 'isColumn',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'reverseInMobile',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'alignItems',
      type: 'text',
      enum: AlignItems as any,
      defaultValue: AlignItems[0],
    },
    {
      name: 'justifyContent',
      type: 'text',
      enum: JustifyContent as any,
      defaultValue: JustifyContent[0],
    },
    {
      name: 'gap',
      type: 'number',
      defaultValue: 20,
    },
    {
      name: 'flexWrap',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Content' } },
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/layout-2.svg',
})
